import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiFilter } from "react-icons/fi";
import { BsSortAlphaDown } from "react-icons/bs";
import Select from "react-select";
import { Form, Tab, Tabs, ProgressBar } from "react-bootstrap";
import {
  FaMinus,
  FaPlus,
  FaStickyNote,
  FaExclamationTriangle,
} from "react-icons/fa";
import { BiErrorCircle } from "react-icons/bi";
import { MdCancel } from "react-icons/md";
import { GrRotateLeft } from "react-icons/gr";
import { API_Link, validateHeader } from "../commons/Constants";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./../assets/sass/style.css";
import "./../assets/sass/totalreview.css";
import gif from "./../assets/img/spin.gif";
import axios from "axios";
import LineChart from "./dashboardComponent/LineChart";
import AreaSpline from "./dashboardComponent/AreaSpline";
import { useSnackbar } from "notistack";
import "react-circular-progressbar/dist/styles.css";
import NestedCircularProgress from "./dashboardComponent/NestedCircularProgressBars ";
import NoteComponent from "./noteComponent";
import parse from "html-react-parser";

function TotalReviewsNew(props) {
  function capitalizeTextProperly(input) {
    // Convert non-string inputs to string
    const text = typeof input === "string" ? input : String(input);

    // Capitalize the first letter of the text
    let capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);

    // Capitalize the first word after specified punctuation marks
    return capitalizedText.replace(
      /([.?!:;]\s*)([a-z])/g,
      (match, punct, char) => {
        // Capitalize the character following the punctuation
        return punct + char.toUpperCase();
      }
    );
  }

  const formatOvidTags = (text) => {
    if (!text) return "";
    const capitalizedText = capitalizeTextProperly(text);
    const formattedText = parse(
      capitalizedText
        .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "<br><b>$1</b>")
        .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
        .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
        .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
        .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
        .replace(/<ovid:br\/>/g, "<br>")
        .replace(
          /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
          "<a href='$1'>$2</a>"
        )
        .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
        .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
        .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>")
    );
    return formattedText;
    //  formattedText.replace(/^(<.*?>)*(\w)/, (match, tags, firstLetter) =>
    //   `${tags || ""}${firstLetter.toUpperCase()}`

    // );
  };
  const MD5hash = validateHeader();
  const [countincluded, setcountincluded] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [articles, setArticles] = useState([]);
  const [total, settotal] = useState();
  const [included, setincluded] = useState([]);
  const [Totalexcluded, setTotalexcluded] = useState([]);
  const [isActive, setIsActive] = useState(null);
  const [processedArticles, setProcessedArticles] = useState([]);
  const [isFeatchingArtices, setIsFeatchingArtices] = useState(false);
  const [excluded, setExcluded] = useState([]);
  const [isGreen, setIsGreen] = useState(
    new Array(articles.length).fill(false)
  );
  const [filtering, setFiltering] = useState(false);
  const [isRed, setIsRed] = useState(new Array(articles.length).fill(false));
  const [isMoveNextLoading, setIsMoveNextLoading] = useState(false);
  const [tabKey, initTabKey] = useState("three");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isError, setIsError] = useState(false);
  const [notes, setNotes] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [savedNotes, setSavedNotes] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentOptions, setCurrentOptions] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [articleData, setArticleData] = useState([]);
  const [normalizedValues, setNormalizedValues] = useState([]); // State for normalized values
  const [isFetchingArticles, setIsFetchingArticles] = useState(false); // State to manage fetching status
  const [page, setPage] = useState(1); // Current page number
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const containerRef = useRef(null); // Reference to the scrollable container
  const dropdownRef = useRef(null);
  const [totalarticles, setTotalarticles] = useState();
  const [isLoadingarticles, setIsLoadingarticles] = useState(false); // Track loading state for API calls
  const [isFetchingNewArticles, setIsFetchingNewArticles] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState({}); // Object to track button loading states
  const [isFilterAppliedButton, setIsFilterAppliedButton] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState(false);
  const [activeAbstract, setActiveAbstract] = useState(null);
  const [text, settext] = useState([]);
  const [isFetchingArticlesAPICalled, setIsFetchingArticlesAPICalled] =
    useState(false);
  const toggleAbstract = (index) => {
    setActiveAbstract(activeAbstract === index ? null : index);
  };
  useEffect(() => {
    setFilteredArticles(articles);
  }, [articles]);
  const toggleFilterModal = () => {
    setAppliedFilter(true);
    setIsFilterAppliedButton(true); // set for aaply button filter
    getFilteredArticles();
    setFiltering(true);
    setShowFilterModal(!showFilterModal);
  };
  const OpenFilterModal = () => {
    setShowFilterModal(!showFilterModal);
  };
  const toggleCloseModal = () => {
    setIsFilterAppliedButton(false);
    setFiltering(false);
    setAppliedFilter(false);
    setArticles([]);
    settext([]);
    getReviewArticles();
    setSelectedOptions([]);
    setCurrentOptions([]);
    setNormalizedValues([]);
    setFilterType("");
    setFilteredArticles(articles);
    setShowFilterModal(false);
  };
  const togglecross = () => {
    setIsFilterAppliedButton(false);
    setFiltering(false);
    setAppliedFilter(false);
    setArticles([]);
    getReviewArticles();
    setSelectedOptions([]);
    settext([]);
    setCurrentOptions([]);
    setNormalizedValues([]);
    setFilterType("");
    setFilteredArticles(articles);
  };
  const handleTitleSearch = (searchTerm) => {
    // Save the search term in a constant
    const titleSearchTerm = searchTerm;
    settext(titleSearchTerm);
  };

  const toggleHideModal = () => {
    setShowFilterModal(!showFilterModal);
  };

  // call for get reviewer permissions
  const [getPermission, setGetPermission] = useState([]);
  function capitalizeWords(str) {
    if (!str || typeof str !== "string") {
      return "Unknown Author"; // or any default text you'd like to show
    }
    return str
      .split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }
  const getPermissionCall = () => {
    var config = {
      method: "get",
      url: `${API_Link}getAllowedStages?review_id=${localStorage.getItem(
        "studyId"
      )}`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        setGetPermission(response.data.permissions[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getData = () => {
    var config = {
      method: "get",
      url: `${API_Link}optionfilter`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        review_id: review_id,
        included: "Yes",
      },
    };
    axios(config)
      .then(function (response) {
        setArticleData(response?.data?.articles);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getFilteredArticles = () => {
    const authors = selectedOptions
      .filter((option) => option.labelPrefix === "authors")
      ?.map((option) => option.value)
      .join(",");

    const journals = selectedOptions
      .filter((option) => option.labelPrefix === "journal")
      ?.map((option) => option.value)
      .join(",");
    // .replace(/\.$/, "");
    const years = selectedOptions
      .filter((option) => option.labelPrefix === "year")
      ?.map((option) => option.value)
      .join(",");

    const title = text;
    var config = {
      method: "get",
      url: `${API_Link}filterArticles`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        review_id: review_id,
        included: "Yes",
        ...(authors && { author: authors }),
        ...(journals && { journal: journals }),
        ...(years && { year: years }),
        ...(title && { title: title }),
      },
    };

    axios(config)
      .then(function (response) {
        setArticles(response?.data?.articles.data);
        setNormalizedValues(selectedOptions);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const navigate = useNavigate();
  let review_id = localStorage.getItem("studyId");
  const handleScroll = () => {
    if (containerRef.current && !filtering) {
      const scrollPercentage =
        (containerRef.current.scrollTop /
          (containerRef.current.scrollHeight -
            containerRef.current.clientHeight)) *
        100;

      const nearBottom = scrollPercentage >= 90;

      if (
        nearBottom &&
        !isFetchingArticles &&
        !isFetchingNewArticles &&
        page < totalPages
      ) {
        setIsLoadingarticles(true);
        setIsFetchingNewArticles(true);

        setTimeout(() => {
          setPage((prevPage) => {
            const nextPage = prevPage + 1;
            getReviewArticles(nextPage);
            setIsLoadingarticles(false);
            setIsFetchingNewArticles(false);
            return nextPage;
          });
        }, 500);
      }
    }
  };
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll, page, totalPages, isFetchingArticles]);

  const getReviewArticles = async (page) => {
    setIsFetchingArticles(true);

    setProgress(0);
    const perPage = 300;

    try {
      const config = {
        method: "get",
        url: `${API_Link}getReviewArticles`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        params: {
          review_id: review_id,
          included: "Yes",
          page: page,
          per_page: perPage,
        },
      };

      const response = await axios(config);
      const resData = response?.data;

      setcountincluded([]);
      setincluded(resData?.included);
      setTotalexcluded(resData?.excluded);
      settotal(resData?.articles?.total);
      const articles = resData?.articles?.data;
      if (articles && articles.length > 0) {
        const updatedArticles = articles
          ?.map((article) => {
            if (article.journal === null || article.journal === "") {
              article.journal = "?";
            }
            if (article.authors === null || article.authors === "") {
              article.authors = "?";
            }

            let abstract_screening = null;
            if (article.current_stage > 2) {
              abstract_screening = 1;
            } else if (
              article.current_stage === 2 &&
              resData.excluded.includes(article.id)
            ) {
              abstract_screening = 0;
            }

            return {
              ...article,
              reason: null,
              abstract_screening,
              labeled: abstract_screening == 1 || abstract_screening == 0,
            };
          })
          .filter((article) => article.abstract && article.title); // Filter out articles with no abstract or title

        // Sort the articles based on the abstract screening state
        const sortedArticles = updatedArticles.sort((a, b) => {
          return (b.abstract_screening ?? -1) - (a.abstract_screening ?? -1);
        });

        // Save notes progressively
        const notesTemp = sortedArticles.reduce((acc, article) => {
          acc[article.id] = article.abstract_screening_note;
          return acc;
        }, {});
        setNotes((prevNotes) => ({ ...prevNotes, ...notesTemp }));

        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          ...Object.fromEntries(
            sortedArticles
              .filter((article) => article.abstract_screening_note !== null)
              ?.map((article) => [article.id, true])
          ),
        }));

        // Append fetched articles to the existing ones
        setArticles((prevArticles) => [...prevArticles, ...sortedArticles]);

        // Update the total number of pages based on the response
        setTotalPages(resData?.articles.last_page);
      }

      setProgress(100); // Set progress to 100% once the fetch is complete
      setTotalarticles(resData?.articles?.total);
    } catch (error) {
      console.error(error);
      setIsError(true);
    } finally {
      setIsFetchingArticles(false);
      setIsFetchingArticlesAPICalled(true);
    }
  };

  const countIncluded = () => {
    return included?.length;
  };

  const countExcluded = () => {
    return Totalexcluded?.length;
  };
const countMaybe = () => {
    const totalValue = Number(total) || 0;
    const includedValue = Number(countIncluded()) || 0;
    const excludedValue = Number(countExcluded()) || 0;

    const countTypes = totalValue - (includedValue + excludedValue);
    return countTypes;
};

  useEffect(() => {
    review_id = localStorage.getItem("studyId");
    getPermissionCall();
    getData();
    getReviewArticles(page);
  }, []);

  const handleClick = (index) => {
    setIsActive(!isActive);
    if (isActive === index) {
      return setIsActive(null);
    }
    setIsActive(index);
  };
  const handleClick2 = (index) => {
    setIsActive(isActive === index ? null : index);
  };

  // code for capitalize
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|of|is|it|on|or|The|to|vs?\.?|via)$/i;
  function shouldBeUppercase(word, index, length) {
    //always capitalize the first and last words
    if (index == 0 || index == length - 1) return true;

    //only capitalize other words if they don't match the small words pattern
    return !smallWords.test(word.toLowerCase());
  }

  function convertFirstLetterToUpperCase(str) {
    //split into words
    const words = str.split(" ");

    //change the case and rejoin into a string
    return words
      ?.map((word, index, length) =>
        shouldBeUppercase(word, index, length)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.toLowerCase()
      )
      .join(" ");
  }
  const selectOptions = currentOptions?.map((option) => {
    let labelPrefix = "";
    switch (filterType) {
      case "year":
        labelPrefix = "year";
        break;
      case "author":
        labelPrefix = "authors";
        break;
      case "journal":
        labelPrefix = "journal";
        break;
      default:
        break;
    }

    // Return the option with prefixed label
    return {
      value: option,
      label: option,
      labelPrefix: labelPrefix,
    };
  });

  const handleInclude = (id, abstract_screening) => {
    let result = [...isGreen];
    result[id] = !result[id];
    setIsGreen(result);

    abstract_screening = 1;
    setArticles(
      articles?.map((item) => {
        if (item.id === id) {
          return { ...item, abstract_screening, labeled: true };
        } else {
          return item;
        }
      })
    );
  };

  const handleExclude = (id, abstract_screening) => {
    let result = [...isRed];
    result[id] = !result[id];
    setIsRed(result);

    abstract_screening = 0;
    setArticles(
      articles?.map((item) => {
        if (item.id === id) {
          return { ...item, abstract_screening, labeled: true };
        } else {
          return item;
        }
      })
    );
  };

  const LabeledRecords = countExcluded() + countIncluded();
  const handleModalInclude = async (id, abstract_screening, current_stage) => {
    const result = articles?.map((article, index) => {
      const result1 = processedArticles.filter(
        (article2) => article2.id == article.id
      );
      if (result1.length > 0) {
        const result = [...isGreen];
        result[id] = !result[id];

        setIsGreen(result);
      }
      return article;
    });

    abstract_screening = 1;
    const IncludeArticle = articles?.map(function (article) {
      var result = processedArticles.filter(
        (article2) => article2.id == article.id
      );
      if (result.length > 0) {
        article.abstract_screening = 1;
        article.labeled = true;
      }
      return article;
    });
    const countTypes = articles.filter((article) => article.labeled === false);
    setIsLoading(true);
    await handlestatus(id, 1, current_stage, "include");
    if (countTypes.length > 0) {
      const data = { articles: IncludeArticle };
      try {
        const config = {
          method: "post",
          url: `${API_Link}getSugestedArticles`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "misr-auth": MD5hash,
          },
          data: data,
        };

        const res = await axios(config);
        setProcessedArticles(res.data);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      setShow(false);
    }
    setIsLoading(false);
  };

  const handleModalExclude = async (id, abstract_screening, current_stage) => {
    articles?.map((article, index) => {
      const result1 = processedArticles.filter(
        (article2) => article2.id == article.id
      );
      if (result1.length > 0) {
        const result = [...isRed];
        result[id] = !result[id];
        setIsRed(result);
      }
      return article;
    });

    abstract_screening = 0;

    const excludeArticle = articles?.map(function (article) {
      var result = processedArticles.filter(
        (article2) => article2.id == article.id
      );
      if (result.length > 0) {
        article.abstract_screening = 0;
        article.labeled = true;
      }
      return article;
    });

    const countTypes = articles?.filter((article) => article.labeled === false);
    await handlestatus(id, 0, current_stage, "exclude");
    if (countTypes?.length > 0) {
      const data = { articles: excludeArticle };

      setIsLoading(true);
      try {
        const config = {
          method: "post",
          url: `${API_Link}getSugestedArticles`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "misr-auth": MD5hash,
          },
          data: data,
        };

        const res = await axios(config);
        setProcessedArticles(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setShow(false);
    }
  };

  let data = { articles: articles };

  const handleActiveLearning = async () => {
    setShow(true);
    setIsLoading(true);

    try {
      const config = {
        method: "post",
        url: `${API_Link}getSugestedArticles`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: data,
      };

      const res = await axios(config);
      setProcessedArticles(res.data);
    } catch (error) {
      alert("Something Went Wrong!, Please Try Again");
    } finally {
      setIsLoading(false); // This will always run after the try or catch block
    }
  };

  const handleFinish = async () => {
    setShow(false);
    toggleCloseModal();
    // const excludedArticleIds = articles
    //   .filter(
    //     (item) =>
    //       item.abstract_screening === 0 || item.abstract_screening === null
    //   )
    //   .map((item) => item.id);
    // const labeledArticleStatus = articles
    //   .filter(
    //     (item) =>
    //       item.abstract_screening === 0 ||
    //       item.abstract_screening === 1 ||
    //       item.abstract_screening === null
    //   )
    //   .map(({ id, abstract_screening, reason }) => {
    //     return { id, abstract_screening, reason: 9 };
    //   });

    // const data = {
    //   review_id: review_id,
    //   stage: "2",
    //   exclusion_purpose: "9",
    //   articles: labeledArticleStatus,
    // };
    // let requestError = null;
    // try {
    //   await axios
    //     .post(`${API_Link}excludeArticles`, data, {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + token,
    //         "misr-auth": MD5hash,
    //       },
    //     })
    //     .then((res) => res.data);
    // } catch (error) {
    //   if (error) {
    //     alert("Something Went Wrong Please Try again");
    //   }
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleMoveNext = async () => {
    navigate("/included");
  };
  const handlestatus = async (
    id,
    abstract_screening,
    current_stage,
    buttonType
  ) => {
    const excludedArticleIds = articles
      .filter(
        (item) =>
          item.abstract_screening === 0 || item.abstract_screening === null
      )
      ?.map((item) => item.id);

    const labeledArticleStatus = [
      {
        id: id,
        abstract_screening: abstract_screening,
        reason: 9,
      },
    ];

    const data = {
      review_id: review_id,
      stage: "2",
      exclusion_purpose: "9",
      articles: labeledArticleStatus,
    };

    setLoadingButtons((prev) => ({
      ...prev,
      [id]: { ...prev[id], [buttonType]: true }, // set loading for the specific button type
    }));
    try {
      await axios
        .post(`${API_Link}excludeArticles`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "misr-auth": MD5hash,
          },
        })
        .then((res) => {
          if (abstract_screening === 1) {
            included.push(id);
            let result = [...isGreen];
            result[id] = !result[id];
            setIsGreen(result);
            setArticles(
              articles?.map((item) => {
                if (item.id === id) {
                  return { ...item, abstract_screening, labeled: true };
                } else {
                  return item;
                }
              })
            );
          } else if (abstract_screening === 0) {
            Totalexcluded.push(id);
            let result = [...isRed];
            result[id] = !result[id];
            setIsRed(result);
            setArticles(
              articles?.map((item) => {
                if (item.id === id) {
                  return { ...item, abstract_screening, labeled: true };
                } else {
                  return item;
                }
              })
            );
          } else if (abstract_screening == null) {
            if (included.includes(id)) {
              const index = included.indexOf(id);
              included.splice(index, 1);
            }

            if (Totalexcluded.includes(id)) {
              const index = Totalexcluded.indexOf(id);
              Totalexcluded.splice(index, 1);
            }
            if (current_stage >= 2) {
              setArticles(
                articles?.map((item) => {
                  if (item.id === id) {
                    return {
                      ...item,
                      current_stage: 2,
                      abstract_screening: null,
                      labeled: false,
                    };
                  } else {
                    return item;
                  }
                })
              );
            }

            if (excluded.includes(id)) {
              setExcluded(excluded.filter((item) => item != id));

              setArticles(
                articles?.map((item) => {
                  if (item.id == id) {
                    return {
                      ...item,
                      abstract_screening: null,
                      labeled: false,
                    };
                  } else {
                    return item;
                  }
                })
              );
            }

            if (isGreen[id]) {
              handleInclude(id);
              setArticles(
                articles?.map((item) => {
                  if (item.id == id) {
                    return {
                      ...item,
                      abstract_screening: null,
                      labeled: false,
                    };
                  } else {
                    return item;
                  }
                })
              );
            }
            if (isRed[id]) {
              handleExclude(id);
              setArticles(
                articles?.map((item) => {
                  if (item.id == id) {
                    return {
                      ...item,
                      abstract_screening: null,
                      labeled: false,
                    };
                  } else {
                    return item;
                  }
                })
              );

              setExcluded(excluded.filter((item) => item !== id));
            }
          }
        });
    } catch (error) {
      if (error) {
        alert("Something Went Wrong Please Try again");
      }
    } finally {
      // Reset loading state for the specific button
      setLoadingButtons((prev) => ({
        ...prev,
        [id]: { ...prev[id], [buttonType]: false }, // reset loading for the specific button type
      }));
    }
  };
  const journals = [
    ...new Set(articleData?.map((article) => article?.journal)),
  ];

  const handleAddNote = (e) => {
    e.preventDefault();
    setShowNoteModal((current) => !current);
  };

  const countUnLabeled = articles
    .filter((article) => article.labeled === false)
    ?.map((article2) => article2.id).length;

  if (isMoveNextLoading)
    return (
      <div className="preload">
        <img src={gif} alt="" />
      </div>
    );
  const handleChangeNote = (e, articleId) => {
    const { value } = e.target;
    setNotes((prevNotes) => ({
      ...prevNotes,
      [articleId]: value, // Update note for the specific article
    }));
  };

  const handleSaveNote = async (articleId) => {
    const noteToSave = notes[articleId];
    setIsSavingNote(true);
    const data = {
      article_id: articleId,
      note: noteToSave,
      abstract: "Yes",
    };
    try {
      const config = {
        method: "post",
        url: `${API_Link}addNote`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: data,
      };

      const res = await axios(config);
      if (res?.data?.note === null) {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: false,
        }));
      } else {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: true,
        }));
      }
    } catch (error) {
      enqueueSnackbar("An Error Occurs While Saving Note", {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } finally {
      setIsSavingNote(false); // This will always run after the try or catch block
    }
  };
  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const sortArticles = (field) => {
    const sorted = [...filteredArticles].sort((a, b) => {
      const valueA = a[field] ? a[field].toString().toLowerCase() : "";
      const valueB = b[field] ? b[field].toString().toLowerCase() : "";
      if (field === "year") {
        return parseInt(valueB) - parseInt(valueA);
      }
      return valueA.localeCompare(valueB);
    });
    setFilteredArticles(sorted);
    setShowDropdown(false);
  };

  const handleFilterChange = (type) => {
    setFilterType(type);
    const normalizedValues = selectedOptions.reduce(
      (acc, option) => {
        if (!acc[option.labelPrefix]) acc[option.labelPrefix] = [];
        acc[option.labelPrefix].push(option.value.toString().toLowerCase());
        return acc;
      },
      { authors: [], journal: [], year: [] }
    );

    const { authors, journal, year } = normalizedValues;

    switch (type) {
      case "year":
        const filteredYears =
          authors.length === 0 && journal.length === 0
            ? [...new Set(articleData?.map((article) => article.year))]
            : articleData
                .filter(
                  (article) =>
                    (authors.length === 0 ||
                      authors.some((author) =>
                        article.authors
                          .split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(author)
                      )) &&
                    (journal.length === 0 ||
                      journal.includes(article.journal.toLowerCase()))
                )
                ?.map((article) => article.year)
                .filter((year, index, self) => self.indexOf(year) === index);

        setCurrentOptions(filteredYears.sort((a, b) => b - a));
        break;

      case "author":
        const filteredAuthors =
          year.length === 0 && journal.length === 0
            ? [
                ...new Set(
                  articleData.flatMap((article) =>
                    article.authors
                      .split(",")
                      ?.map((a) => a.trim().toLowerCase())
                  )
                ),
              ]
            : articleData
                .filter(
                  (article) =>
                    (year.length === 0 ||
                      year.includes(article.year.toString().toLowerCase())) &&
                    (journal.length === 0 ||
                      journal.includes(article.journal.toLowerCase()))
                )
                .flatMap((article) =>
                  article.authors.split(",")?.map((a) => a.trim().toLowerCase())
                )
                .filter(
                  (author, index, self) => self.indexOf(author) === index
                ); // Remove duplicates

        // Capitalize the first letter of each word in the filtered authors
        const capitalizedAuthors = filteredAuthors?.map(capitalizeWords);
        setCurrentOptions(capitalizedAuthors);
        break;

      case "journal":
        const filteredJournals =
          year.length === 0 && authors.length === 0
            ? journals
            : journals.filter((journal) =>
                articleData.some(
                  (article) =>
                    (year.length === 0 ||
                      year.includes(article.year.toString().toLowerCase())) &&
                    (authors?.length === 0 ||
                      authors.some((author) =>
                        article?.authors
                          .split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(author)
                      )) &&
                    article?.journal.toLowerCase() === journal.toLowerCase()
                )
              );

        setCurrentOptions(filteredJournals?.map(capitalizeWords));
        break;

      default:
        setCurrentOptions([]);
        break;
    }
  };

  const handleSelectChange = (options) => {
    setSelectedOptions(options || []);
  };

  const highlightText = (text) => {
    if (!text || typeof text !== "string") return text;

    if (
      !normalizedValues ||
      !Array.isArray(normalizedValues) ||
      normalizedValues.length === 0
    ) {
      return text;
    }

    // Extract values to highlight based on labelPrefix
    const authors = normalizedValues
      .filter((item) => item.labelPrefix === "authors")
      ?.map((item) => item.value.toString().toLowerCase());

    const journals = normalizedValues
      .filter((item) => item.labelPrefix === "journal")
      ?.map((item) => item.value.toString().toLowerCase());

    const years = normalizedValues
      .filter((item) => item.labelPrefix === "year")
      ?.map((item) => item.value.toString().toLowerCase());

    // Combine all values into a single array for regex highlighting
    const allValues = [...authors, ...journals, ...years];

    // Create a regex pattern for highlighting
    const pattern = allValues.join("|"); // Join all values with '|' to create a regex pattern
    if (!pattern) return text; // If there are no values to highlight, return original text

    // Split the text by the regex pattern and highlight matches
    const parts = text.split(new RegExp(`(${pattern})`, "gi")); // Use the pattern for splitting
    return parts?.map((part, index) =>
      allValues?.some((value) => value === part.toLowerCase()) ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const highlightTitle = (highlight, text) => {
    if (!text || typeof text !== "string") return text;
    if (!highlight || typeof highlight !== "string") return text;

    // Convert the highlight term to lowercase for case-insensitive matching
    const pattern = highlight.toLowerCase();

    // Split the text by the regex pattern and highlight matches
    const parts = text.split(new RegExp(`(${pattern})`, "gi")); // Use the pattern for splitting
    return parts?.map((part, index) =>
      part.toLowerCase() === pattern ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  return (
    <div
      ref={containerRef}
      className="page--content--abstract"
      onClick={handleClickOutside}
    >
      <div className="position-sticky position-sticky-top z-index-9">
        <div className="page--section">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="page--heading">Abstract Screening</h1>
            </div>
            <div className="col-lg-6 abstract-ai-move-next-btn-container">
              {getPermission && getPermission.includes(2) ? (
                <>
                  <Button
                    variant="success"
                    onClick={handleActiveLearning}
                    className={
                      countIncluded() === 0 ||
                      countExcluded() === 0 ||
                      countUnLabeled === 0 ||
                      isFeatchingArtices
                        ? "modal--positioning ai-btn cursor-not-allowed"
                        : "modal--positioning ai-btn"
                    }
                    disabled={
                      countIncluded() === 0 ||
                      countExcluded() === 0 ||
                      countUnLabeled === 0 ||
                      isFeatchingArtices
                    }
                  >
                    Auto Abstract Screening (AI)
                  </Button>
                </>
              ) : (
                ""
              )}

              <button
                className={
                  countIncluded() === 0 || isFeatchingArtices
                    ? "btn btn-warning move-next-btn cursor-not-allowed"
                    : "btn btn-warning move-next-btn"
                }
                onClick={handleMoveNext}
                disable={countIncluded() === 0 || isFeatchingArtices}
              >
                Move To Next
              </button>
            </div>
          </div>
          <div className="row d-flex align-items-center justify-content-center mt-3">
            <div className="col-lg-4 text-start">
              <div
                style={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  marginLeft: "8px",
                }}
              >
                <button
                  onClick={toggleDropdown}
                  className={
                    filteredArticles?.length === 0
                      ? "d-flex content-align-center align-items-center sort-filter-btn opacity-50 cursor-not-allowed"
                      : "d-flex content-align-center align-items-center sort-filter-btn "
                  }
                >
                  <BsSortAlphaDown size={18} /> Sort
                </button>
                {showDropdown && (
                  <div
                    ref={dropdownRef}
                    style={{
                      position: "absolute",
                      top: "30px",
                      left: 0,
                      backgroundColor: "#ffff",
                      boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                      zIndex: 1,
                      padding: "8px",
                    }}
                  >
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("title")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Title
                    </div>
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("journal")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Journal
                    </div>
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("authors")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Authors
                    </div>
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("year")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Year
                    </div>
                  </div>
                )}
                {isFilterAppliedButton ? (
                  <div className="  applied-filter-btn">
                    <div
                      className="d-flex content-align-center align-items-center applied-filter-svg"
                      onClick={OpenFilterModal}
                    >
                      <FiFilter size={18} /> Applied
                    </div>
                    <div
                      onClick={() => {
                        togglecross();
                      }}
                      className="ms-2 d-flex content-align-center align-items-center applied-cross-btn  fw-bold"
                    >
                      <MdCancel size={18} />
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={OpenFilterModal}
                    className={
                      filteredArticles?.length === 0
                        ? "sort-filter-btn d-flex content-align-center align-items-center opacity-50 cursor-not-allowed"
                        : "sort-filter-btn d-flex content-align-center align-items-center"
                    }
                  >
                    <FiFilter size={18} /> Filter
                  </button>
                )}
              </div>
            </div>

            <div className="col-lg-8 text-end">
              <span className="count-wrapper-abstract count-colour">
                {appliedFilter ? (
                  <span className="me-3 text-dark">
                    <strong>Filtered Article(s) </strong>
                    {articles.length} out of {totalarticles}
                  </span>
                ) : (
                  <span className="me-3 text-dark">
                    Total Articles: <strong>{totalarticles}</strong>
                  </span>
                )}
                <span className="me-3 text-success">
                  Included: <strong>{countIncluded()}</strong>
                </span>
                <span className="me-3 text-danger">
                  Excluded: <strong>{countExcluded()}</strong>
                </span>
                <span>
                  Undecided: <strong>{countMaybe()}</strong>
                </span>
              </span>
            </div>
          </div>
          <Modal
            show={showFilterModal}
            onHide={toggleHideModal}
            className="overflow-hidden"
          >
            <Modal.Header closeButton>
              <Modal.Title>Filter Options</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Form className="d-flex justify-content-around mb-2">
                  <Form.Check
                    type="radio"
                    label="Year"
                    name="filterType"
                    value="title"
                    checked={filterType === "year"}
                    onChange={() => handleFilterChange("year")}
                  />
                  <Form.Check
                    type="radio"
                    label="Author"
                    name="filterType"
                    value="author"
                    checked={filterType === "author"}
                    onChange={() => handleFilterChange("author")}
                  />
                  <Form.Check
                    type="radio"
                    label="Journal"
                    name="filterType"
                    value="journal"
                    checked={filterType === "journal"}
                    onChange={() => handleFilterChange("journal")}
                  />
                  <Form.Check
                    type="radio"
                    label="Title"
                    name="filterType"
                    value="title"
                    checked={filterType === "title"}
                    onChange={() => handleFilterChange("title")}
                  />
                </Form>
                <Select
                  options={selectOptions}
                  isMulti
                  value={selectedOptions}
                  onChange={handleSelectChange}
                  closeMenuOnSelect={false}
                  placeholder="Select filter options..."
                  isDisabled={filterType === "title"} // Disable Select when "Title" is selected
                />

                {filterType === "title" ? (
                  <input
                    type="text"
                    placeholder="Search by title..."
                    className="form-control"
                    value={text}
                    onChange={(e) => handleTitleSearch(e.target.value)}
                  />
                ) : (
                  ""
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              {selectedOptions.length > 0 || text.length > 0 ? (
                <Button
                  variant="secondary"
                  onClick={() => {
                    toggleCloseModal();
                  }}
                >
                  Reset
                </Button>
              ) : (
                <Button variant="secondary" disabled className="opacity-50 ">
                  Reset
                </Button>
              )}
              {selectedOptions.length || text.length > 0 ? (
                <Button
                  variant="primary"
                  onClick={() => {
                    toggleFilterModal();
                  }}
                >
                  Apply Filter
                </Button>
              ) : (
                <Button
                  className="opacity-50 "
                  // variant="primary"
                  disabled
                >
                  Apply Filter
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </div>
        {isFeatchingArtices && (
          <div className="progressBarData">
            <ProgressBar now={progress} />
          </div>
        )}
      </div>

      <>
        <Modal
          className="modal-xl abstract--modal modal-dialog-centered screening-abstract-modal overflow-hidden "
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className="" style={{ height: "10%" }}>
            <h4 className="mb-2">
              {/* <strong>Most Relevant Abstract</strong> */}
            </h4>
            {isLoading ? (
              <button
                className="btn btn-danger"
                disabled
                style={{ cursor: "not-allowed" }}
              >
                Stop Active Learning
              </button>
            ) : (
              <button className="btn btn-danger" onClick={handleFinish}>
                Stop Active Learning
              </button>
            )}
          </Modal.Header>
          {/* activeKey={tabKey} onSelect={(e) => initTabKey(e)} */}
          <div className="modal-tabs-content" style={{ height: "71%" }}>
            <Tabs
              className="text-dark"
              activeKey={tabKey}
              onSelect={(e) => initTabKey(e)}
            >
              <Tab
                eventKey="three"
                title="Most Relevant"
                className="modal--tab-buttons"
                style={{ height: "100%" }}
              >
                {isLoading ? (
                  <div className="preload--modal">
                    <img src={gif} alt="" />
                  </div>
                ) : (
                  <>
                    {processedArticles &&
                      processedArticles?.length > 0 &&
                      processedArticles?.map(
                        (
                          {
                            id,
                            title,
                            abstract,
                            authors,
                            journal,
                            current_stage,
                          },
                          index
                        ) => {
                          return (
                            <>
                              <div
                                className="col-lg-12"
                                style={{ height: "100%" }}
                                key={index}
                              >
                                <div
                                  className="auto--screening--wrapper pt-1 pl-1"
                                  style={{ height: "100%" }}
                                >
                                  <h1 className="heading3 auto-screening-heading">
                                    {formatOvidTags(
                                      convertFirstLetterToUpperCase(title)
                                    )}
                                  </h1>
                                  <p className="small text-muted auto-screening-title">
                                    {capitalizeWords(authors)}
                                  </p>
                                  <div
                                    className="inner--box--row mb-1"
                                    style={{
                                      height: "70%",
                                      overflowY: "scroll",
                                    }}
                                  >
                                    {/* <span className='index--numbering'>{id}</span> */}

                                    <div className="included-modal active-learning">
                                      <label className="form-check-label">
                                        {" "}
                                        {!journal == "?"
                                          ? convertFirstLetterToUpperCase(
                                              journal
                                            )
                                          : ""}{" "}
                                      </label>
                                      <div>
                                        <p className="Increase-height--of--paragraph ">
                                          {formatOvidTags(abstract)}
                                        </p>
                                        <span className="d-flex justify-content-end">
                                          <button
                                            className="btn add-note-btn"
                                            onClick={(e) =>
                                              handleAddNote(e, id)
                                            }
                                          >
                                            Add Note
                                          </button>
                                        </span>
                                        {showNoteModal ? (
                                          <NoteComponent
                                            id={id}
                                            notes={notes}
                                            handleChangeNote={handleChangeNote}
                                            handleSaveNote={handleSaveNote}
                                            isSavingNote={isSavingNote}
                                            savedNotes={savedNotes}
                                          />
                                        ) : (
                                          " "
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-center exclude-include-button">
                                <button
                                  onClick={() =>
                                    handleModalExclude(id, 0, current_stage)
                                  }
                                  className="mx-2 exclude-btn"
                                >
                                  Exclude
                                </button>
                                <button
                                  onClick={() =>
                                    handleModalInclude(id, 1, current_stage)
                                  }
                                  className="mx-2 include-btn"
                                >
                                  Include
                                </button>
                              </div>
                            </>
                          );
                        }
                      )}
                  </>
                )}
              </Tab>
              <Tab
                eventKey="four"
                title="Analytics"
                className="modal--tab-buttons"
                style={{ height: "100%" }}
              >
                {isLoading ? (
                  <div className="preload--modal">
                    <img src={gif} alt="" />
                  </div>
                ) : (
                  <div className="modal--content">
                    <div className="row text-center">
                      <div className="col-md-7 col">
                        <div className="col-12">
                          <div
                            style={{
                              padding: "20px",
                              backgroundColor: "#f8f9fa",
                              borderRadius: "10px",
                            }}
                          >
                            {/* Total Articles */}
                            <div style={{ marginBottom: "25px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <h5
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Total Articles
                                </h5>
                                <h5
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {totalarticles}
                                </h5>
                              </div>
                              <ProgressBar
                                now={totalarticles}
                                max={totalarticles}
                                variant="secondary"
                                style={{
                                  height: "7px",
                                  backgroundColor: "#e9ecef",
                                  borderRadius: "10px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                              />
                            </div>

                            {/* Labeled Records */}
                            <div style={{ marginBottom: "25px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Labeled Records
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {LabeledRecords}
                                </p>
                              </div>
                              <ProgressBar
                                now={LabeledRecords}
                                max={totalarticles}
                                variant="info"
                                style={{
                                  height: "7px",
                                  backgroundColor: "#e9ecef",
                                  borderRadius: "10px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                              />
                            </div>

                            {/* Irrelevant Records */}
                            <div style={{ marginBottom: "25px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Irrelevant Records Since Last Relevant
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {countExcluded()}
                                </p>
                              </div>
                              <ProgressBar
                                now={countExcluded()}
                                max={totalarticles}
                                variant="Irrelevant"
                                style={{
                                  height: "7px",
                                  backgroundColor: "#e9ecef",
                                  borderRadius: "10px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                              />
                            </div>

                            <div style={{ marginBottom: "25px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Relevant Records
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6c757d",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {countIncluded()}
                                </p>
                              </div>
                              <ProgressBar
                                now={countIncluded()}
                                max={totalarticles}
                                variant="warning"
                                style={{
                                  height: "7px",
                                  backgroundColor: "#e9ecef",
                                  borderRadius: "10px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-5 col">
                        <div className="card tab-pie-card ">
                          <NestedCircularProgress
                            labeledRecords={LabeledRecords}
                            irrelevantRecords={countExcluded()}
                            relevantRecords={countIncluded()}
                            totalRecords={totalarticles}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div
                      className="row text-center"
                      style={{ marginTop: "20px" }}
                    >
                      <div className="col-md-6">
                        <div className="card p-1">
                          <LineChart
                            numberOfRelevantRecords={countIncluded()}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card p-1">
                          <AreaSpline
                            numberOfReviewedRecords={articles.length}
                            numberOfRelevantRecords={countIncluded()}
                          />
                        </div>
                      </div>
                    </div> */}
                  </div>
                )}
              </Tab>
            </Tabs>
          </div>

          <Modal.Footer>
            <button
              className="btn btn-success footer-button"
              // onClick={handleFinish}
            >
              Finish
            </button>
          </Modal.Footer>
        </Modal>
      </>
      <div>
        {filteredArticles &&
          filteredArticles?.length > 0 &&
          filteredArticles?.map(
            (
              {
                id,
                title,
                abstract,
                authors,
                journal,
                current_stage,
                doi,
                year,
                abstract_screening,
              },
              index
            ) => (
              <div className="row z-index-0" key={index}>
                <div
                  className={
                    current_stage > 2 || isGreen[id]
                      ? "inner--box--row green d-flex flex-column"
                      : excluded.includes(id) ||
                        isRed[id] ||
                        abstract_screening === 0
                      ? "inner--box--row red d-flex flex-column"
                      : "inner--box--row d-flex flex-column"
                  }
                >
                  <div style={{ width: "100%" }} className="d-flex">
                    <span className="index--numbering fw-bold">
                      {index + 1})
                    </span>
                    <div style={{ width: "100%" }} className="row">
                      <div className="width--70">
                        <h1 className="heading3">
                          {highlightTitle(
                            text,
                            formatOvidTags(convertFirstLetterToUpperCase(title))
                          )}
                        </h1>

                        {authors && authors !== "?" && (
                          <div className="d-flex ">
                            <p className="small text-muted authors-font ms-1">
                              <span className="authors-font fw-bold">
                                Author(s):
                              </span>{" "}
                              {highlightText(
                                capitalizeWords(authors.replace(/,/g, ", ")) +
                                  ".",
                                normalizedValues
                              )}
                            </p>
                          </div>
                        )}
                        {journal ? (
                          <label
                            className="small text-muted journal-font"
                            htmlFor="flexCheckDefault2"
                          >
                            <span className="fw-bold">Journal:</span>{" "}
                            {highlightText(
                              capitalizeWords(journal) + ".",
                              normalizedValues
                            )}
                          </label>
                        ) : (
                          ""
                        )}
                        <div>
                          {year ? (
                            <label className="small text-muted journal-font">
                              <span className="fw-bold">Year:</span>{" "}
                              {highlightText(
                                capitalizeWords(year.toString()),
                                normalizedValues
                              )}
                            </label>
                          ) : (
                            ""
                          )}
                        </div>

                        <p
                          className={
                            activeAbstract === index
                              ? "Increase-height--of--paragraph "
                              : "Increase-height--of--paragraph underline-showAbstarct"
                          }
                          onClick={() => toggleAbstract(index)}
                          style={{ cursor: "pointer" }}
                        >
                          {activeAbstract === index && abstract
                            ? formatOvidTags(abstract)
                            : // ? abstract
                              "Show Abstract"}
                        </p>
                      </div>
                      <div className="width-30">
                        <div className="">
                          <div className="btn--new--ul">
                            {/* Add Note button */}
                            <Link
                              to="#"
                              className="link position-relative"
                              title="Add Note"
                              onClick={() => handleClick(index)}
                              disabled={loadingButtons[id]?.addNote}
                            >
                              {loadingButtons[id]?.addNote ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                ></span>
                              ) : (
                                <FaStickyNote />
                              )}
                            </Link>

                            {/* Check permission and condition for displaying Undo, Include, Exclude */}
                            {getPermission && getPermission.includes(2) ? (
                              <>
                                {isGreen[id] ||
                                isRed[id] ||
                                current_stage > 2 ||
                                excluded.includes(id) ||
                                abstract_screening === 0 ? (
                                  <Link
                                    to="#"
                                    className="link"
                                    title="Undo"
                                    onClick={() =>
                                      handlestatus(
                                        id,
                                        null,
                                        current_stage,
                                        "undo"
                                      )
                                    } // Pass 'undo'
                                    disabled={loadingButtons[id]?.undo} // Disable the button during loading for Undo
                                  >
                                    {loadingButtons[id]?.undo ? (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                      ></span> // Loader for Undo
                                    ) : (
                                      <GrRotateLeft /> // Default Undo icon
                                    )}
                                  </Link>
                                ) : (
                                  <span>
                                    {/* Include button */}
                                    <Link
                                      to="#"
                                      className="link"
                                      title="Include"
                                      onClick={() =>
                                        handlestatus(
                                          id,
                                          1,
                                          current_stage,
                                          "include"
                                        )
                                      } // Pass 'include'
                                      disabled={loadingButtons[id]?.include} // Disable the button during loading for Include
                                    >
                                      {loadingButtons[id]?.include ? (
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                        ></span> // Loader for Include
                                      ) : (
                                        <FaPlus /> // Default Include icon
                                      )}
                                    </Link>

                                    {/* Exclude button */}
                                    <Link
                                      to="#"
                                      className="link"
                                      title="Exclude"
                                      onClick={() =>
                                        handlestatus(
                                          id,
                                          0,
                                          current_stage,
                                          "exclude"
                                        )
                                      } // Pass 'exclude'
                                      disabled={loadingButtons[id]?.exclude} // Disable the button during loading for Exclude
                                    >
                                      {loadingButtons[id]?.exclude ? (
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                        ></span> // Loader for Exclude
                                      ) : (
                                        <FaMinus /> // Default Exclude icon
                                      )}
                                    </Link>
                                  </span>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      {isActive === index && (
                        <NoteComponent
                          id={id}
                          notes={notes}
                          handleChangeNote={handleChangeNote}
                          handleSaveNote={handleSaveNote}
                          isSavingNote={isSavingNote}
                          savedNotes={savedNotes}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
      </div>

      {isFetchingArticles && (
        <div
          // className={
          //   filteredArticles?.length >= 100 ? "loading-second-time" : "preload"
          // }
          className="loading-second-time"
        >
          <img src={gif} alt="Loading..." />
        </div>
      )}
      {isError && !isFetchingArticles && isFetchingArticlesAPICalled && (
        <div className="no-data-found-main">
          <h5 className="no-data-found text-muted m-auto opacity-50">
            <BiErrorCircle size={50} color="orange" />
            <span className="ms-3">Some thing went wrong.</span>
          </h5>
        </div>
      )}
      {!isFetchingArticles &&
        filteredArticles?.length === 0 &&
        !isError &&
        isFetchingArticlesAPICalled && (
          <div className="no-data-found-main">
            <h5 className="no-data-found text-muted m-auto opacity-50">
              <FaExclamationTriangle size={50} color="orange" />
              <span className="ms-3">There are no abstract screening.</span>
            </h5>
          </div>
        )}
    </div>
  );
}

export default TotalReviewsNew;
